class AuthorisationService {

    constructor($rootScope, $state, $q, ApiService, $window) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$q = $q;
        this.$window = $window;
        this.ApiService = ApiService;
    }

    $onInit() {
        //this.principal = null;
    }

    login(credentials) {
        var self = this;
        var endpoint = '/admin/login_check';

        credentials._username = credentials.username;
        credentials._password = credentials.password;
        delete credentials.username;
        delete credentials.password;
        
        return self.ApiService.post(endpoint, credentials)
            .then(function(response){
                //self.principal = response.data.user;
                self.setUser(response.data.user);
                self.$state.go('app.racedays');
            });

    }

    logout() {
        this.$window.localStorage.removeItem('token');
        this.$window.localStorage.removeItem('principal');
    }

    updatePassword(password) {
        var self = this;
        
        var endpoint = '/api/adminusers';

        var data = {
            password: password
        };
        return self.ApiService.put(endpoint, data);
    }

    getToken() {
        return this.$window.localStorage.authToken;
    }

    setToken(token) {
        this.$window.localStorage.authToken = token;
    }

    getUser() {
        var userJson = this.$window.localStorage.principal;
        if(userJson){
            return JSON.parse(this.$window.localStorage.principal);
        }
        return null;
    }

    setUser(principal) {
        if(principal) {
            this.$window.localStorage.principal = JSON.stringify(principal);
        }
    }

    isAuthenticated() {

        var self = this;
        var token = self.getToken();
        var principal = self.getUser();

        if(principal && token){

            // check if token has expired
            var params = self.parseJwt(token);
            return Math.round(new Date().getTime() / 1000) <= params.exp;
        }
        else {
            return false;
        }
    }

    authorise(roles) {
        var self = this;
        var defered = self.$q.defer();
        var principal = self.getUser();
        if(roles.indexOf(principal.roles[0]) !== -1 || roles.indexOf('*') !== -1){
            defered.resolve();
        }
        else {
            defered.reject();
        }
        return defered.promise;
    }

    parseJwt (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(this.$window.atob(base64));
    }

}
AuthorisationService.$inject = ['$rootScope', '$state', '$q', 'ApiService', '$window'];
export default AuthorisationService;